import { combineReducers } from 'redux';
// LOAD USER ACTIVITIES
export const loadUserActivitiesState = {
    data: null,
    metadata: null,
    isLoading: false,
    error: null,
};
const loadUserActivitiesReducer = (state = loadUserActivitiesState, action) => {
    switch (action.type) {
        case 'OLY_ENGINE_STORE_LOAD_USER_ACTIVITIES':
            return { ...state, isLoading: true, error: null };
        case 'OLY_ENGINE_STORE_LOAD_USER_ACTIVITIES_SUCCESS':
            return {
                ...state,
                isLoading: false,
                data: action.payload.metadata.skip > 0 && state.data
                    ? [...state.data, ...action.payload.data]
                    : action.payload.data,
                metadata: action.payload.metadata,
            };
        case 'OLY_ENGINE_STORE_LOAD_USER_ACTIVITIES_ERROR':
            return { ...state, isLoading: false, error: action.payload.error };
        case 'OLY_ENGINE_STORE_RESET_USER_ACTIVITIES':
            return loadUserActivitiesState;
        default:
            return state;
    }
};
// REPLAY USER ACTIVITY
export const replayUserActivityState = {
    replayedActivityId: null,
    isLoading: false,
    error: null,
};
const replayUserActivityReducer = (state = replayUserActivityState, action) => {
    switch (action.type) {
        case 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY':
            return { replayedActivityId: null, isLoading: true, error: null };
        case 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY_SUCCESS':
            return {
                replayedActivityId: action.payload.activityId,
                isLoading: false,
                error: null,
            };
        case 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY_ERROR':
            return { ...state, isLoading: false, error: action.payload.error };
        case 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY_RESET':
            return replayUserActivityState;
        default:
            return state;
    }
};
// CREATE USER ACTIVITY
export const createUserActivityState = {
    createdActivity: null,
    isLoading: false,
    error: null,
};
const createUserActivityReducer = (state = createUserActivityState, action) => {
    switch (action.type) {
        case 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY':
            return { createdActivity: null, isLoading: true, error: null };
        case 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY_SUCCESS':
            return {
                createdActivity: true,
                isLoading: false,
                error: null,
            };
        case 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY_ERROR':
            return { ...state, isLoading: false, error: action.payload.error };
        case 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY_RESET':
            return createUserActivityState;
        default:
            return state;
    }
};
// EDIT USER ACTIVITY
export const editUserActivityState = {
    editedActivityId: null,
    isLoading: false,
    error: null,
};
const editUserActivityReducer = (state = editUserActivityState, action) => {
    switch (action.type) {
        case 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY':
            return { editedActivityId: null, isLoading: true, error: null };
        case 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY_SUCCESS':
            return {
                editedActivityId: action.payload.activityId,
                isLoading: false,
                error: null,
            };
        case 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY_ERROR':
            return { ...state, isLoading: false, error: action.payload.error };
        case 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY_RESET':
            return editUserActivityState;
        default:
            return state;
    }
};
// DELETE USER ACTIVITY
export const deleteUserActivityState = {
    deletedActivityId: null,
    isLoading: false,
    error: null,
};
const deleteUserActivityReducer = (state = deleteUserActivityState, action) => {
    switch (action.type) {
        case 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY':
            return { deletedActivityId: null, isLoading: true, error: null };
        case 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY_SUCCESS':
            return {
                deletedActivityId: action.payload.activityId,
                isLoading: false,
                error: null,
            };
        case 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY_ERROR':
            return { ...state, isLoading: false, error: action.payload.error };
        case 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY_RESET':
            return deleteUserActivityState;
        default:
            return state;
    }
};
export const userActivitiesState = {
    loadUserActivities: loadUserActivitiesState,
    replayUserActivity: replayUserActivityState,
    createUserActivity: createUserActivityState,
    editUserActivity: editUserActivityState,
    deleteUserActivity: deleteUserActivityState,
};
export default combineReducers({
    loadUserActivities: loadUserActivitiesReducer,
    replayUserActivity: replayUserActivityReducer,
    createUserActivity: createUserActivityReducer,
    editUserActivity: editUserActivityReducer,
    deleteUserActivity: deleteUserActivityReducer,
});
